import React from "react";
import { Grid } from "@mui/material";
import { DateTime, Duration } from "luxon";
import { useFormContext } from "react-hook-form";
import { isDurationGreaterThan } from "utils/Validation/isDurationGreaterThan";
import { FormTimePicker } from "components/form/FormTimePicker";

const baseTimeOptions = {
  required: {
    value: true,
    message: "Please enter or select a time.",
  },
  validate: {
    validDate: (v: DateTime) => {
      return v.isValid || "Please enter a valid time.";
    },
  },
};

export function CloudSubscriptionMaintenanceWindowForm() {
  const { watch } = useFormContext();

  const currentOutageWindowStartUtc = watch("outageWindowStartUtc");
  const currentOutageWindowEndUtc = watch("outageWindowEndUtc");

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <FormTimePicker
          label="Maintenance Window Start Time"
          name="outageWindowStartUtc"
          defaultValue={DateTime.utc().startOf("day")}
          rules={{
            ...baseTimeOptions,
            validate: {
              ...baseTimeOptions.validate,
              lessThanEndTime: (v: DateTime) => {
                return (
                  !currentOutageWindowEndUtc ||
                  isDurationGreaterThan(
                    v,
                    currentOutageWindowEndUtc,
                    Duration.fromObject({
                      hours: 1,
                      minute: 59,
                    })
                  ) ||
                  "Maintenance window start time should be at least 2 hours before the maintenance window ends."
                );
              },
            },
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <FormTimePicker
          label="Maintenance Window End Time"
          name="outageWindowEndUtc"
          defaultValue={DateTime.utc().startOf("day").plus({ hours: 2 })}
          rules={{
            ...baseTimeOptions,
            deps: ["outageWindowStartUtc"],
            validate: {
              ...baseTimeOptions.validate,
              greaterThanStartTime: (v: DateTime) => {
                return (
                  !currentOutageWindowStartUtc ||
                  isDurationGreaterThan(
                    currentOutageWindowStartUtc,
                    v,
                    Duration.fromObject({
                      hours: 1,
                      minutes: 59,
                    })
                  ) ||
                  "Maintenance window end time should be at least 2 hours after the maintenance window starts."
                );
              },
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
